import styled from "styled-components";
import Colors from "../../constants/Colors";

export const LandingSubHeroArea = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 calc(50vw - 575px);
`;

export const LandingSubHeroAreaBreadcrumb = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.white};
  margin-bottom: 15px;
  
  @media (max-width: 768px) {
    color: ${Colors.black};
  }

`;

export const LandingSubHeroAreaTitle = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: 0;
  color: ${Colors.white};
  margin-bottom: 50px;
  
  @media (max-width: 768px) {
    color: ${Colors.black};
    margin-bottom: 0;
  }
`;

export const LandingSubHeroAreaDescription = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  > div {
    margin-left: 0;
    margin-right: 0;
    background: unset;
    margin-bottom: 23px;

    > div.property-lines-container {
      padding-top: 23px;
      padding-bottom: 35px;
      background: ${Colors.white};

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const LandingReklamContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 40px 24px 65px 24px;
  background: rgba(0, 0, 0, 0.03);
`;

export const LandingReklamContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 100px;
  padding: 0 calc(50vw - 575px);
`;

export const LandingReklamContentImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`;

export const LandingReklamContentText = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  box-sizing: border-box;

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0;
    color: ${Colors.blackColor};
    margin-bottom: 15px;
  }

}
`;
